export default "__VITE_ASSET__Ba$ZWLRb__"